const IPIFY_URL = "https://api64.ipify.org";

const getPublicIPAddress = async (): Promise<string> => {
  const result = await fetch(IPIFY_URL);
  return result.text();
};

export default getPublicIPAddress;
